import { Component, Input, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertPopupService } from '../../services/alert-popup.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
	selector: 'confirmation-dialog',
	templateUrl: './confirmation.component.html',
	styleUrls: ['./dialog.component.scss'],
	providers: [Subject],
})
export class ConfirmationModal implements OnInit {
	@Output() onSuccessEvent = new EventEmitter();
	private emailInputSubject = new Subject<string>();

	constructor(
		public dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: {
			dialogTitle: string,
			dialogMessage: string,
			dailogCancelBtnTitle: string,
			dailogSuccessBtnTitle: string,
			params: any,
			isInput: any
		},
		private alertService: AlertPopupService,
	) {
	}

	private _dialogTitle: string;

	get dialogTitle(): string {
		return this._dialogTitle;
	}

	set dialogTitle(value: string) {
		this._dialogTitle = value;
	}

	private _dialogMessage: string;

	get dialogMessage(): string {
		return this._dialogMessage;
	}

	set dialogMessage(value: string) {
		this._dialogMessage = value;
	}

	private _dailogCancelBtnTitle: string;

	get dailogCancelBtnTitle(): string {
		return this._dailogCancelBtnTitle;
	}

	set dailogCancelBtnTitle(value: string) {
		this._dailogCancelBtnTitle = value;
	}

	private _dailogSuccessBtnTitle: string;

	get dailogSuccessBtnTitle(): string {
		return this._dailogSuccessBtnTitle;
	}

	set dailogSuccessBtnTitle(value: string) {
		this._dailogSuccessBtnTitle = value;
	}

	private _params: any;

	get params(): any {
		return this._params;
	}

	set params(value: any) {
		this._params = value;
	}

	private _isInput: any;

	get isInput(): any {
		return this._isInput;
	}

	set isInput(value: any) {
		this._isInput = value;
	}

	ngOnInit(): void {
		this.dialogTitle = this.data.dialogTitle;
		this.dialogMessage = this.data.dialogMessage;
		this.dailogSuccessBtnTitle = this.data.dailogSuccessBtnTitle;
		this.dailogCancelBtnTitle = this.data.dailogCancelBtnTitle;
		this.params = this.data.params;
		this.isInput = this.data.isInput
		this.setupSearchObservable();
	}

	onSuccess() {
		this.onSuccessEvent.emit(this.params);
	}


	private setupSearchObservable(): void {
		this.emailInputSubject
			// .pipe(debounceTime(600))
			.subscribe((email: string) => {
				this.params = email
			});
	}


	EmailData(event: any) {
		this.emailInputSubject.next(event);
	}

}
